import def from "csi/def";
import { Field } from "csi/def/Field";
import { FormView } from "csi/form/View";
import Widget from "csi/form/Widget";
import csi from "csi/main";
import reflection from "csi/reflection";
import Names from "csi/store/Names";
import csiStore from "csi/store/_base";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import SupplierRequestMasterRightWidget from "./SupplierRequestMasterRightWidget";

const SupplierRequestMasterForm = declare(Widget, {
	SRM_PRODUCTS: "SRMProducts",
	SR_SUBTYPE: "SRSubtype",
	SRM_SUPPLIER_REQUEST_TEMPLATE: "SRMSupplierRequestTemplate",

	/**
	 * @override
	 */
	_resolveView(): void {
		this.inherited(arguments);
		this.rightWidgetClass = SupplierRequestMasterRightWidget;
		const parentNode = this.getFormData()
			.getParent();
		const rc = reflection.getNodeClass(parentNode);
		const subtypeField = this.getField(this.SR_SUBTYPE);
		const productsField = this.getField(this.SRM_PRODUCTS);
		if (rc?.isDerivedFrom("BaseProduct")) {
			this.addFixedValue(this.SRM_PRODUCTS, [parentNode.$URL]);
		} else if (productsField){
			productsField.omitFromReport = true;
		}
		if (subtypeField) {
			subtypeField.m_onChange = "_onChangeSubtype";
		}
		if (productsField) {
			productsField.m_onChange = "_onChangeProduct";
			const requestType = this.defView.getSource().m_action.classControllerParams["requestType"];
			if (requestType === "DataPackageContainerType:Style") {
				productsField.m_label = "Styles";
			}
			else if (requestType === "DataPackageContainerType:Material") {
				productsField.m_label = "Materials";
			}
		}
	},

	/**
	 * @override
	 */
	_buildForm(): void {
		this.inherited(arguments);
		this._updateStatistics();
	},

	/**
	 * Update side panel statistics each time SRMProducts field value is changed
	 */
	_onChangeProduct(formView: FormView, field: Field, value: any) {
		this._updateStatistics();
	},

	/**
	 * Clear SRMSupplierRequestTemplate and SRMProducts fields with the change on SRSubtype field
	 */
	_onChangeSubtype(formView: FormView, field: Field, value: any) {
		const parentNode = this.getFormData()
			.getParent();
		const rc = reflection.getNodeClass(parentNode);
		if (!rc?.isDerivedFrom("BaseProduct")) {
			this.resetFieldStoreAndValue(this.SRM_PRODUCTS, []);
		}
		this.resetFieldStoreAndValue(this.SRM_SUPPLIER_REQUEST_TEMPLATE, csi.EMPTY_URL);
		this._updateStatistics();
	},
	
	/**
	 * @override
	 * Add fixed value for Product value on Product level form
	 * @returns - FieldStore
	 */
	getFieldStore(field: Field, value: string): any {
		const name = field.getControlName();
		const { cacheView } = this;
		if (name === this.SRM_PRODUCTS) {
			// optimization: do not query for all products when product is set
			const fixedValue = this.getFixedValue(name);
			if (fixedValue) {
				const fixedValueNode = cacheView.getNode(fixedValue);
				return new Names({
					data: [csiStore.nameObject(fixedValueNode)],
				});
			}
		}
		return this.inherited(arguments);
	},

	/**
	 * @override
	 */
	onWriteFormReport(field, writer, formInfo) {
		const { nodeUrl, contextUrl } = formInfo;
		const requestType = this.defView.getSource().m_action.classControllerParams["requestType"];
		writer.changeNode(nodeUrl)
			.changeAttribute("RequestType", xml.ATTR_ENUM, requestType)
			.publishAttribute("HierarchyLevel", xml.ATTR_REF, contextUrl);
	},

	/**
     * set panel statistics
     */
	_updateStatistics(): void {
		const supplierRequestMasterGenerated = 1;
		const productsValue =  this.getFieldValue(this.SRM_PRODUCTS);
		const numProducts = productsValue ? productsValue.length : 0;
		this.rightWidget.set("supplierRequestMasterName", "");
		this.rightWidget.set("numSupplierRequestMaster", supplierRequestMasterGenerated);
		this.rightWidget.set("numProducts", numProducts);
	},
});
export = SupplierRequestMasterForm;